<template>
  <div class="pt-md-2 pt-0 mt-md-3 text-center">
    <div v-if="hasChosenRentAdm" class="bg-primary mt-5 pb-5 pt-5">
      <div class="small-container bg-white p-5 box-shadow">
        <h2 class="font-weight-light mt-3">
          <span class="font-weight-bold">
            {{ translationPlanHeader }}
          </span>
        </h2>
        <p class="font-weight-light mt-3">Her er bare noe av det du kan forvente fremover....</p>
        <div class="row mt-5 pt-4">
          <div class="col-12 col-lg-6 pl-5 pr-5">
            <div class="feature-icon text-dark">
              <i class="budicon-good-trends"></i>
            </div>

            <h6 class="mt-4" v-if="isSubscriptionBasic">Innkreving av husleien</h6>
            <p v-if="isSubscriptionBasic">skjer uten at du behøver å gjøre noe.</p>

            <h6 class="mt-4" v-if="isSubscriptionPremium">Innkreving av husleien</h6>
            <p v-if="isSubscriptionPremium">skjer automatisk hver måned</p>

            <h6 class="mt-4" v-if="isSubscriptionPro">Fakturering av husleien</h6>
            <p v-if="isSubscriptionPro">skjer automatisk hver måned</p>
          </div>
          <div class="col-12 col-lg-6 pl-5 pr-5">
            <div class="feature-icon text-dark">
              <i class="budicon-mobile-payment"></i>
            </div>

            <h6 class="mt-4">Purring og inkasso</h6>
            <p>iverksettes ved forsinket betaling av husleien</p>
          </div>
        </div>

        <div class="row mt-4">
          <div class="col-12 col-lg-6 pl-5 pr-5">
            <div class="feature-icon text-dark">
              <i class="budicon-line-chart"></i>
            </div>

            <h6 class="mt-4">Husleien indeksreguleres</h6>
            <p>automatisk hvert år hvis funksjonen aktiveres</p>
          </div>
          <div class="col-12 col-lg-6 pl-5 pr-5">
            <div class="feature-icon text-dark">
              <i v-if="isSubscriptionBasic || isSubscriptionPro" class="budicon-dashboard"></i>
              <i v-if="isSubscriptionPremium" class="budicon-lock"></i>
            </div>

            <h6 class="mt-4" v-if="isSubscriptionPremium">Utleieforsikring fra Kolibri Forsikring</h6>
            <p v-if="isSubscriptionPremium">gir deg dekning ved boligskade eller ubetalt husleie</p>

            <h6 class="mt-4" v-if="isSubscriptionBasic || isSubscriptionPro">Tilgang til MinHusleie</h6>
            <p v-if="isSubscriptionBasic || isSubscriptionPro">hvor du kan administrere alt i leieforholdet</p>
          </div>
        </div>

        <hr class="mt-5" />

        <div class="row pt-3">
          <div class="col">
            <p v-if="isSubscriptionPremium" style="font-size: 0.9rem">
              Ved å gå videre bekrefter du at du ønsker forvaltning via Husleie.no, og aksepter samtidig våre
              <a href="/juridisk/abonnementsvilkar/" target="_blank">abonnementsvilkår</a>,
              <a href="/juridisk/personvern/" target="_blank">personvernerklæring</a> og
              <a
                href="https://www.husleie.no/wp-content/uploads/2025/06/Vilkar-Utleieforsikring-Final-Kolibri.pdf"
                target="_blank"
                rel="noopener"
                >utleieforsikringens vilkår</a
              >. Du vil motta bekreftelse og mer info på e-post.
            </p>
            <p v-else style="font-size: 0.9rem">
              Ved å gå videre bekrefter du at du ønsker forvaltning via Husleie.no, og aksepter samtidig våre
              <a href="/juridisk/abonnementsvilkar/" target="_blank">abonnementsvilkår</a> og
              <a href="/juridisk/personvern/" target="_blank">personvernerklæring</a>. Du vil motta bekreftelse og mer
              info på e-post.
            </p>
            <router-link :to="{ name: 'rentAdm' }" tag="button" class="btn btn-primary">neste</router-link>
          </div>
        </div>
      </div>
    </div>
    <!-- / 1) If Chosen Plan (Grey Section) -->

    <!-- 2) Show Plans -->
    <div class="bg-light pt-5 pb-5">
      <div class="small-container">
        <div v-if="!hasChosenRentAdm" class="mb-5 pb-3">
          <!-- No plan selected -->
          <hl-H1>{{ translationBuySubscription }}</hl-H1>
          <p class="text-left">
            Forvalter du leieforholdet på Husleie.no får du en enklere, tryggere og mer effektiv hverdag som utleier.
            Velg et abonnement, men vil du bare ha depositumskonto så kan du selvfølgelig det.
          </p>
        </div>

        <div v-if="!hasChosenRentAdm" class="pb-5">
          <!-- If landlord type is Private -->
          <div v-if="isPrivateLandlord">
            <!-- Pricing Component - Data defined in the data() object of this page -->
            <div class="row mt-5 align-items-center">
              <div class="col-12 col-md-6 pr-3 pr-md-0">
                <hl-PricingPlan
                  :highlighted="privatePlans[0].highlighted"
                  :title="privatePlans[0].title"
                  :subtitle="privatePlans[0].subtitle"
                  :iconClass="privatePlans[0].iconClass"
                  :isFree="privatePlans[0].isFree"
                  :price="privatePlans[0].price"
                  :features="shortPrivateFeatures"
                  :index="0"
                  :subscription="depAccount.subscription"
                  @planSet="$emit('changedPlan', 'basic')"
                >
                </hl-PricingPlan>
              </div>

              <div class="col-12 col-md-6 pl-3 pl-md-0 mt-5 mt-md-0">
                <hl-PricingPlan
                  :highlighted="privatePlans[1].highlighted"
                  :title="privatePlans[1].title"
                  :subtitle="privatePlans[1].subtitle"
                  :iconClass="privatePlans[1].iconClass"
                  :isFree="privatePlans[1].isFree"
                  :price="privatePlans[1].price"
                  :features="shortPrivateFeatures"
                  :index="1"
                  :subscription="depAccount.subscription"
                  @planSet="$emit('changedPlan', 'premium')"
                >
                </hl-PricingPlan>
              </div>
            </div>
            <!-- / Pricing Component -->
          </div>
          <!-- / If landlord type is Private -->

          <!-- If landlord type is Company -->
          <div v-if="isProfessionalLandlord">
            <!-- Pricing Component - Data defined in the data() object of this page -->
            <div class="row mt-5 justify-content-center">
              <div class="col-12 col-lg-6">
                <hl-PricingPlan
                  :highlighted="companyPlans[0].highlighted"
                  :title="companyPlans[0].title"
                  :subtitle="companyPlans[0].subtitle"
                  :iconClass="companyPlans[0].iconClass"
                  :isFree="companyPlans[0].isFree"
                  :price="companyPlans[0].price"
                  :priceExtra="companyPlans[0].priceExtra"
                  :features="shortCompanyFeatures"
                  :index="0"
                  :subscription="depAccount.subscription"
                  @planSet="$emit('changedPlan', 'basic')"
                >
                </hl-PricingPlan>
              </div>
            </div>
            <!-- / Pricing Component -->
          </div>
          <!-- / If landlord type is Company -->
        </div>

        <div class="row">
          <div class="col">
            <div>
              <a-RenderHTML :value="translationPricePlanClarification" />
            </div>
            <router-link :to="{ name: 'sign' }">
              <button class="btn btn-outline-secondary mt-5 mb-5" @click="cleanSubscriptions">
                Jeg vil bare ha depositumskonto
              </button>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <!-- / 2) Show Plans-->

    <!-- 4) Plan Compare -->
    <div class="bg-primary pt-5 pb-5">
      <div class="small-container text-left pl-lg-0 pr-lg-0">
        <hl-H1 class="text-white"
          >Funksjonalitet og tjenester i {{ isProfessionalLandlord ? 'abonnementet' : 'abonnementene' }}
        </hl-H1>
      </div>

      <div class="small-container bg-white box-shadow">
        <div ref="comparePlans">
          <!-- Comparison Table -->
          <div class="row">
            <div class="col table-responsive">
              <table class="table table-borderless table-striped">
                <!-- Table heads -->
                <!-- If landlord.type is private -->
                <thead v-if="isPrivateLandlord">
                  <tr>
                    <th scope="col"></th>
                    <th v-for="(plan, j) in privatePlans" :key="j" scope="col">
                      <h5>{{ plan.title }}</h5>

                      <div class="price mt-3">
                        <p v-if="plan.isFree" class="font-weight-light">
                          <span>Gratis</span>
                        </p>
                        <p v-else>
                          <span>{{ plan.price }} kr</span>
                          <span class="font-weight-normal"> / mnd.</span>
                        </p>
                      </div>
                    </th>
                  </tr>
                </thead>
                <!-- If landlord.type is private -->

                <!-- If landlord.type is company -->
                <thead v-if="isProfessionalLandlord">
                  <tr>
                    <th scope="col"></th>
                    <th v-for="(plan, j) in companyPlans" :key="j" scope="col">
                      <h5>{{ plan.title }}</h5>
                      <div class="price mt-3">
                        <p v-if="plan.isFree" class="font-weight-light">
                          <span>Gratis</span>
                        </p>
                        <p v-else :class="{ 'mb-0 pb-0': plan.priceExtra }">
                          <span>kr {{ plan.price }}</span>
                          <span class="font-weight-normal"> / mnd.</span>
                          <span v-if="plan.priceExtra" class="font-weight-normal pt-0 d-block">{{
                            plan.priceExtra
                          }}</span>
                        </p>
                      </div>
                    </th>
                  </tr>
                </thead>
                <!-- If landlord.type is company -->
                <!-- / Table heads -->

                <!-- Table bodies -->
                <!-- If landlord.type is private -->
                <tbody v-if="isPrivateLandlord">
                  <tr v-for="(feature, i) in privateFeatures" :key="i">
                    <td scope="row">
                      {{ feature.name }}
                    </td>
                    <!-- Hide Basic if Premium is selected -->
                    <td>
                      <hl-Icon
                        v-if="feature.included[0] === true"
                        type="checkmark"
                        rounded
                        variation="success"
                      ></hl-Icon>
                      <div v-else>
                        <hl-Icon v-if="feature.included[0] === false" type="cross" rounded variation="alert"></hl-Icon>
                        <span v-else>{{ feature.included[0] }}</span>
                      </div>
                    </td>
                    <td>
                      <hl-Icon
                        v-if="feature.included[1] === true"
                        type="checkmark"
                        rounded
                        variation="success"
                      ></hl-Icon>
                      <div v-else>
                        <hl-Icon v-if="feature.included[1] === false" type="cross" rounded variation="alert"></hl-Icon>
                        <span v-else>{{ feature.included[1] }}</span>
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td scope="row"></td>
                    <td>
                      <router-link
                        :to="{ name: 'rentAdm' }"
                        tag="button"
                        class="btn btn-sm btn-outline-primary"
                        @click.native="depAccount.upsale.rentadm.plan = 'basic'"
                        >velg
                      </router-link>
                    </td>
                    <td>
                      <router-link
                        :to="{ name: 'rentAdm' }"
                        tag="button"
                        class="btn btn-sm btn-primary"
                        @click.native="depAccount.upsale.rentadm.plan = 'premium'"
                        >velg
                      </router-link>
                    </td>
                  </tr>
                </tbody>
                <!-- / If landlord.type is private -->

                <!-- If landlord.type is company -->
                <tbody v-if="isProfessionalLandlord">
                  <tr v-for="(feature, i) in companyFeatures" :key="i">
                    <td scope="row">
                      {{ feature.name }}
                    </td>
                    <td>
                      <hl-Icon
                        v-if="feature.included[0] === true"
                        type="checkmark"
                        rounded
                        variation="success"
                      ></hl-Icon>
                      <div v-else>
                        <hl-Icon v-if="feature.included[0] === false" type="cross" rounded variation="alert"></hl-Icon>
                        <span v-else>{{ feature.included[0] }}</span>
                      </div>
                    </td>
                    <td>
                      <hl-Icon
                        v-if="feature.included[1] === true"
                        type="checkmark"
                        rounded
                        variation="success"
                      ></hl-Icon>
                      <div v-else>
                        <hl-Icon v-if="feature.included[1] === false" type="cross" rounded variation="alert"></hl-Icon>
                        <span v-else>{{ feature.included[1] }}</span>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td scope="row"></td>
                    <td>
                      <router-link
                        :to="{ name: 'sign' }"
                        tag="button"
                        class="btn btn-sm btn-primary"
                        @click.native="depAccount.upsale.rentadm.plan = 'basic'"
                        >velg
                      </router-link>
                    </td>
                  </tr>
                </tbody>
                <!-- / If landlord.type is company -->
                <!-- Table bodies -->
              </table>
            </div>
          </div>

          <div class="mt-3 text-left pb-5">
            <div class="asterisk-wrapper">
              <ul>
                <li v-for="asterisk in asterisks">
                  <span v-html="asterisk" />
                </li>
              </ul>
            </div>

            <p v-if="isSubscriptionPremium" style="font-size: 0.9rem">
              Ved å gå videre bekrefter du at du ønsker forvaltning via Husleie.no, og aksepter samtidig våre
              <a href="/juridisk/abonnementsvilkar/" target="_blank">abonnementsvilkår</a>,
              <a href="/juridisk/personvern/" target="_blank">personvernerklæring</a> og
              <a
                href="https://www.husleie.no/wp-content/uploads/2025/06/Vilkar-Utleieforsikring-Final-Kolibri.pdf"
                target="_blank"
                rel="noopener"
                >utleieforsikringens vilkår</a
              >. Du vil motta bekreftelse og mer info på e-post.
            </p>
            <p v-else style="font-size: 0.9rem">
              Ved å gå videre bekrefter du at du ønsker forvaltning via Husleie.no, og aksepter samtidig våre
              <a href="/juridisk/abonnementsvilkar/" target="_blank">abonnementsvilkår</a> og
              <a href="/juridisk/personvern/" target="_blank">personvernerklæring</a>. Du vil motta bekreftelse og mer
              info på e-post.
            </p>
          </div>
          <!-- / Comparison Table -->
        </div>
        <!-- / 4) Plan Compare -->
      </div>
    </div>

    <hl-NextBackBottomBar
      buttonSize="lg"
      backText="tilbake"
      backLink="deposit"
      :displayNext="false"
      :params="{ id: contract_id }"
      @validateAll="$validator.validateAll()"
    />
  </div>
</template>

<style scoped lang="scss">
.box-shadow {
  box-shadow: $box-shadow-2;
  -webkit-box-shadow: $box-shadow-2;
}

.table th,
.table td {
  vertical-align: middle;
  padding: 0.6rem;
  font-size: 0.8em;
}

.feature-icon {
  margin: auto;

  i {
    font-size: 2em;
    color: $primary;
  }
}

.asterisk-wrapper {
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;

  ul,
  li {
    margin: 0;
    padding: 0;
    list-style: none;
  }

  li {
    padding-left: 20px;
    font-size: 14px;
  }

  li:nth-child(1):before {
    content: '* ';
  }

  li:nth-child(2):before {
    content: '** ';
  }

  li:nth-child(3):before {
    content: '*** ';
  }

  li:nth-child(4):before {
    content: '**** ';
  }

  li:nth-child(5):before {
    content: '***** ';
  }
}
</style>

<script>
import NextBackBottomBar from '@/components/NextBackBottomBar.vue';
import RenderHTML from '@modules/design-system/components/atoms/RenderHTML.vue';
import H1 from '@modules/husleie-framework/src/components/headings/H1.vue';
import Icon from '@modules/husleie-framework/src/components/icons/Icon.vue';
import PricingPlan from '@modules/husleie-framework/src/components/pricing/PricingPlan.vue';
import i18nCommon from '@modules/i18n/mixins/Common';
import hlValidateBeforeLeave from '@modules/husleie-framework/src/mixins/hlValidateBeforeLeave';

export default {
  mixins: [hlValidateBeforeLeave, i18nCommon],
  props: {
    depAccount: Object,
    contract_id: String,
    isSubscriptionBasic: Boolean,
    isSubscriptionPremium: Boolean,
    isSubscriptionPro: Boolean,
    hasChosenRentAdm: Boolean,
    planLoading: Boolean,
  },

  components: {
    'hl-H1': H1,
    'hl-Icon': Icon,
    'hl-PricingPlan': PricingPlan,
    'hl-NextBackBottomBar': NextBackBottomBar,
    'a-RenderHTML': RenderHTML,
  },

  watch: {
    planLoading(newValue, oldValue) {
      if (oldValue && !newValue) {
        this.$nextTick(() => {
          window.scrollTo(0, 0);
        });
      }
    },
  },

  methods: {
    scrollToComparePlans() {
      this.$nextTick(() => {
        this.$refs.comparePlans.scrollIntoView({ behavior: 'smooth' });
      });
    },
    cleanSubscriptions() {
      this.depAccount.upsale.rentadm.plan = 'none';
    },

    showPlanModal(plan) {
      this.showPlanTermsModal = true;
      this.bufferPlan = plan;
      // setBufferPlan();
    },
  },

  computed: {
    isPrivateLandlord() {
      return this.getLandlordType === 'private';
    },
    isProfessionalLandlord() {
      return this.getLandlordType === 'company';
    },
    getLandlordType() {
      return this.depAccount.landlord.type;
    },
    shortPrivateFeatures() {
      return [
        {
          name: this.translate('rent.collection of the rent'),
          included: [true, true],
        },
        {
          name: this.translate('plan.deposit account'),
          included: [true, true],
        },
        {
          name: this.translate('invoice.reminder and debt collection'),
          included: [true, true],
        },
        {
          name: this.translate('rent.indexAdjustment.annual index adjustment'),
          included: [true, true],
        },
        {
          name: `${this.translate('plan.legal assistance information')} (${this.translatePlural(
            'hour',
            1
          )}/${this.translatePlural('year', 1, { n: null })})`,
          included: [false, true],
        },
        {
          name: this.translate('legal.legal assistance'),
          included: [false, true],
        },
        {
          name: this.translate('insurance.landlord insurance for losses related to unpaid rent'),
          included: [false, true],
        },
        {
          name: this.translate('plan.insurance for property damage'),
          included: [false, true],
        },
        {
          name: this.translate('plan.telephone support'),
          included: [true, true],
        },
      ];
    },
    asterisks() {
      return [
        this.translateAsteriskOne,
        this.translateAsteriskTwo,
        this.translateAsteriskThree,
        this.translateAsteriskFour,
        this.translateAsteriskFive,
      ];
    },
    subscriptionPlanName() {
      if (this.isSubscriptionPro) {
        return 'Business';
      }
      if (this.isSubscriptionBasic) {
        return 'Basic';
      }
      if (this.isSubscriptionPremium) {
        return 'Premium';
      }
      return '';
    },
    translateAsteriskOne() {
      return 'Depositumskonto er inkludert i abonnementene Basic og Premium gitt at abonnementet er aktivt i 12 sammenhengende måneder. Hvis abonnementet varer mindre enn 12 måneder eller du kun ønsker en depositumskonto vil du bli fakturert kr 599 for depositumskontoen.';
    },
    translateAsteriskTwo() {
      return this.translate('insurance.included in {insurer} rental insurance', {
        insurer: '<a href="https://www.husleie.no/utleier/utleieforsikring" target="_blank">Kolibri Forsikring</a>',
      });
    },
    translateAsteriskThree() {
      return this.translate('plan.advert price');
    },
    translateAsteriskFour() {
      return this.translate('plan.credit check cost');
    },
    translateAsteriskFive() {
      return this.translate('plan.{insurer} plan covers lawyer to bring case and includes 30min follow up', {
        insurer: '<a href="https://www.husleie.no/utleier/utleieforsikring" target="_blank">Kolibri Forsikring</a>',
      });
    },
    translationPricePlanClarification() {
      return '* Depositumskonto er inkludert i abonnementene Basic og Premium gitt at abonnementet er aktivt i 12 sammenhengende måneder. Hvis abonnementet varer mindre enn 12 måneder eller du kun ønsker en depositumskonto vil du bli fakturert kr 599 for depositumskontoen.\n\nUtleieforsikringen i Premium-abonnementet krever et depositum som tilsvarer minimum tre måneders husleie.\n\nUnder kan du se detaljert liste over funksjonalitet og tjenester eller bare velge å opprette depositumskonto.';
    },
    translationPlanHeader() {
      return this.translate('plan.you have chosen {plan} management of your tenancy', {
        plan: this.subscriptionPlanName
      });
    },
    translationBuySubscription() {
      return this.translate('plan.Buy subscription to get free deposit account');
    },
  },

  mounted() {
    /* GTM Tracking */
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'VirtualPageview',
      virtualPageURL: '/depositaccount/step3/choose',
      virtualPageTitle: 'Deposit Account | Step 3 | Choose',
    });
  },

  updated() {
    this.$emit('updated');
  },

  data() {
    return {
      bufferPlan: '',
      bufferPlanTitleAndPrice: '',
      showPlanTermsModal: false,
      privatePlans: [
        {
          title: 'Basic',
          subtitle: 'Enkel boligutleie',
          iconClass: 'budicon-mansion',
          highlighted: false,
          isFree: false,
          price: '99',
        },
        {
          title: 'Premium',
          subtitle: 'Trygg og enkel boligutleie',
          iconClass: 'budicon-business-area',
          highlighted: true,
          isFree: false,
          price: '199',
        },
      ],

      companyPlans: [
        {
          title: 'Business',
          subtitle: 'Proff og effektiv boligutleie',
          iconClass: 'budicon-mansion',
          highlighted: true,
          isFree: false,
          price: '99',
          priceExtra: '(eller pris etter avtale)',
        },
      ],

      shortCompanyFeatures: [
        {
          name: 'Innkreving av husleien',
          included: [true],
        },
        {
          name: this.translate('plan.deposit account'),
          included: [true, true],
        },
        {
          name: 'Purring og inkasso',
          included: [true],
        },
        {
          name: 'Årlig indeksregulering',
          included: [true],
        },
        {
          name: 'Dashboard og rapporter',
          included: [true],
        },
        {
          name: 'Regnskapsdata',
          included: [true],
        },
        {
          name: 'Portefølje og flerbruker',
          included: [true],
        },
        {
          name: 'Juridisk bistand (e.a.)',
          included: [true],
        },
        {
          name: '...pluss mye mer',
          included: [true],
        },
      ],

      privateFeatures: [
        {
          name: 'Leiekontrakt m/ BankID',
          included: [true, true],
        },
        {
          name: 'Depositumskonto *',
          included: ['fra ' + this.toCurrency('NOK', 0), 'fra ' + this.toCurrency('NOK', 0)],
        },
        {
          name: 'Overtakelsesprotokoll',
          included: [true, true],
        },
        {
          name: 'Tilgang MinHusleie',
          included: [true, true],
        },
        {
          name: 'Fakturering av husleien (auto)',
          included: [true, true],
        },
        {
          name: 'Purring og inkasso (auto)',
          included: [true, true],
        },
        {
          name: 'Indeksregulering årlig (auto)',
          included: [true, true],
        },
        {
          name: 'Annonsering til FINN.no ***',
          included: [true, true],
        },
        {
          name: 'Interessehåndtering',
          included: [true, true],
        },
        {
          name: 'Kredittsjekk av interessenter ****',
          included: [true, true],
        },
        {
          name: 'SMS-utsendelse',
          included: [true, true],
        },
        {
          name: 'Meldingssenter',
          included: [true, true],
        },
        {
          name: 'Boligskade opp til kr 500 000 **',
          included: [false, true],
        },
        {
          name: 'Tapt husleie opp til 6 mnd **',
          included: [false, true],
        },
        {
          name: 'Merutgifter ifbm fravikelse **',
          included: [false, true],
        },
        {
          name: 'Fravikelse med advokatbistand *****',
          included: ['kr 3 500', true],
        },
        {
          name: 'Juridisk bistand',
          included: ['kr 750/15m', '1 time/år'],
        },
        {
          name: 'Kundeservice',
          included: ['Epost+Tlf', 'Epost+Tlf'],
        },
        {
          name: 'Pris per måned per leieforhold',
          included: ['kr 99', 'kr 199'],
        },
      ],

      companyFeatures: [
        {
          name: 'Leiekontrakt m/ BankID',
          included: [true],
        },
        {
          name: 'Depositumskonto',
          included: ['fra ' + this.toCurrency('NOK', 0)],
        },
        {
          name: 'Overtakelsesprotokoll',
          included: [true],
        },
        {
          name: 'Tilgang MinHusleie',
          included: [true],
        },
        {
          name: 'Fakturering av husleien (auto)',
          included: [true],
        },
        {
          name: 'Purring og inkasso (auto)',
          included: [true],
        },
        {
          name: 'Indeksregulering årlig (auto)',
          included: [true],
        },
        {
          name: 'Annonsering til FINN.no **',
          included: [true],
        },
        {
          name: 'Interessehåndtering',
          included: [true],
        },
        {
          name: 'Kredittsjekk av interessenter ***',
          included: [true],
        },
        {
          name: 'SMS-utsendelse',
          included: [true],
        },
        {
          name: 'Meldingssenter',
          included: [true],
        },
        {
          name: 'Regnskapsdata m/eksport',
          included: [true],
        },
        {
          name: 'Rapporter',
          included: [true],
        },
        {
          name: 'Dashboard m/ nøkkeltall',
          included: [true],
        },
        {
          name: 'Flerbruker',
          included: [true],
        },
        {
          name: 'Utleierprofiler / Portefølje',
          included: [true],
        },
        {
          name: 'Begjæring om fravikelse ****',
          included: ['E. avtale'],
        },
        {
          name: 'Juridisk bistand',
          included: ['E. avtale'],
        },
        {
          name: 'Kundeservice',
          included: ['Epost+Tlf'],
        },
        {
          name: '...pluss mye mer',
          included: [],
        },
        {
          name: 'Pris per måned per leieforhold',
          included: ['kr 99'],
        },
      ],
    };
  },
};
</script>
